var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { ui } from "../../../contracts";
import { FilterPredicate, MainGroupConfiguration, GroupingFilterTypes } from "../../../data";
import { getHeaderNames, getTagNumber } from "../../../helpers";
import { CustomHeading, EventList, ViewAllLink, ViewAllBtn, ViewMoreBtn, MainContentWrap, FavoritesWrap, EventCardPlaceholder, MiniEventCardPlaceholder, SecondaryHeadingPicker } from "../components";
import "blocks/EventListPresenter/ui/EventListPresenter.less";
let EventListPresenter = class EventListPresenter extends React.Component {
    constructor(props) {
        super(props);
        this.dict = this.props.dict;
        this.cms = this.props.cms;
        this.state = this.props.dataProvider;
        this.renderedSubheadings = 0;
        this.renderedMainheadings = 0;
    }
    getGroupingFilterConfig() {
        if (this.cms.GroupingFilterType === GroupingFilterTypes.None) {
            return undefined;
        }
        return this.state[`get${this.cms.GroupingFilterType}Config`];
    }
    getEventHeadingCount(isMain, sportId) {
        const eventFunction = isMain
            ? "displayEventByMainGrouping"
            : "displayEvents";
        return this.state.provider.filterManager.isCurrentMainFilter(FilterPredicate.LiveStreaming)
            ? this.state[eventFunction](sportId).length
            : this.state.provider.eventsCountBySport[sportId] || this.state[eventFunction](sportId).length;
    }
    getDefaultHeadingProps(index, mainHeading, subHeading) {
        const isMain = !subHeading;
        const heading = subHeading || mainHeading;
        return {
            key: `${isMain ? "main" : "sub"}-heading-${index}`,
            id: index.toString(),
            name: this.state.shouldRenderGameLines(mainHeading, isMain)
                ? this.dict.GameLines
                : heading.name,
            cms: this.cms,
            dict: this.dict,
            eventsCountLength: this.getEventHeadingCount(isMain, heading.id),
            marketNames: this.prepareMarketNames(mainHeading, isMain),
            marketTemplates: this.state.getMarketTemplates(mainHeading.sportId),
            cardType: this.state.provider.getCardConfigBySportId(mainHeading.sportId, this.state.isMiniEventCard).cardType,
            showMarketsFilter: heading.marketsFilterEnabled,
            renderedHeadings: isMain
                ? this.renderedMainheadings++
                : this.renderedSubheadings++
        };
    }
    getMainHeadingProps(mainHeadings, index) {
        const heading = mainHeadings[index];
        return Object.assign(Object.assign({}, this.getDefaultHeadingProps(index.toString(), heading)), {
            subName: heading.subname,
            groupingFilterConfig: this.getGroupingFilterConfig(),
            shouldCollapse: (mainHeadings.length > 1),
            toggleOddsBtn: this.renderToggleOddsBtn(index),
            mbnTag: getTagNumber(heading.mbnIcon)
        });
    }
    getSubHeadingProps(mainHeading, subheading) {
        const index = this.state.generateSubheadingId(mainHeading.id, subheading.id);
        return this.getDefaultHeadingProps(index, mainHeading, subheading);
    }
    showPlaceholder() {
        return this.state.isMiniEventCard
            ? React.createElement(MiniEventCardPlaceholder, { eventsCount: this.cms.EventsCount })
            : React.createElement(EventCardPlaceholder, { eventsCount: this.cms.EventsCount });
    }
    showMessage() {
        return this.state.isLoading
            ? this.showPlaceholder()
            : React.createElement(ui.Message, { text: this.dict.NoEvents, type: ui.MessageStates.info });
    }
    prepareMarketNames(mainHeading, isMainHeading) {
        const shouldShowNames = this.state.shouldShowNamesInHeading(mainHeading, isMainHeading);
        return shouldShowNames
            ? getHeaderNames(this.state.provider.getCardConfigBySportId(mainHeading.sportId, this.state.isMiniEventCard), this.dict, mainHeading.sportId, isMainHeading)
            : [];
    }
    renderViewAllLive() {
        return React.createElement(ViewAllBtn, { onClick: this.state.openViewAllLiveLink.bind(this.state), text: this.dict.ViewAllBtn, linkUrl: this.state.getViewAllLiveLink() });
    }
    renderViewMore() {
        return React.createElement(ViewMoreBtn, { onClick: this.state.viewMore.bind(this.state), text: this.dict.ViewMore });
    }
    renderEvents(events, mainHeading, chunks, subHeading) {
        const id = subHeading ? subHeading.id : mainHeading.id;
        return React.createElement(React.Fragment, null,
            !subHeading
                && this.state.shouldShowCustomSubheading(mainHeading)
                && this.renderCustomSubheading(mainHeading),
            React.createElement(EventList, { state: this.state, events: events, cms: this.cms, eventChunkHeights: chunks, dict: this.dict }, this.renderViewAllLink(id, mainHeading, subHeading)));
    }
    renderViewAllLink(id, mainHeading, subHeading) {
        const linkUrl = subHeading && subHeading.linkUrl
            ? subHeading.linkUrl
            : mainHeading.linkUrl || "";
        return React.createElement(React.Fragment, null, React.createElement(ViewAllLink, { title: this.dict.ViewAllLink, handler: this.state.openLeagueTranspiler.bind(this.state, mainHeading.sportId, id), href: linkUrl }));
    }
    renderFavoritesSection() {
        return React.createElement(FavoritesWrap, { name: this.dict.Favorites, cms: this.props.cms, state: this.state, getMarketNames: this.prepareMarketNames.bind(this), getEvents: this.renderEvents.bind(this) });
    }
    renderCustomSubheading(mainHeading) {
        const cardType = this.state.provider.getCardConfigBySportId(mainHeading.sportId, this.state.isMiniEventCard).cardType;
        const marketTemplates = [];
        return React.createElement(CustomHeading, { id: mainHeading.id, marketNames: this.prepareMarketNames(mainHeading, false), marketTemplates: marketTemplates, cardType: cardType });
    }
    renderToggleOddsBtn(index) {
        return {
            shouldShow: index === 0
                && this.state.isMiniEventCard
                && !this.state.showFavoritesSection
                && !this.state.isYourBetModeEnabled,
            toggled: this.state.showOddBtns,
            tooltipMessage: this.state.tooltipMessage,
            onClick: this.state.toggleOddsBtnOnClick
        };
    }
    renderEventsContent(mainHeading, mainIndex) {
        if (this.state.shouldHideSubheadings) {
            const displayEvents = this.state.displayEvents(mainHeading.id);
            const eventChunkHeights = this.state.getEventsHeight(displayEvents);
            return this.renderEvents(displayEvents, mainHeading, eventChunkHeights);
        }
        else {
            return this.state.displaySubheadings(this.getCorrectSubheadingId(mainHeading))
                .map((subheading, subIndex) => {
                const eventChunkHeights = this.state.getEventsHeight(subheading.displayEvents);
                return React.createElement(SecondaryHeadingPicker, Object.assign({}, this.getSubHeadingProps(mainHeading, subheading)), this.state.showFavoritesSection && subheading.displayEvents.length === 0
                    ? React.createElement(ui.Message, { text: this.dict.AllEventsInFavorites, type: ui.MessageStates.info })
                    : this.renderEvents(subheading.displayEvents, mainHeading, eventChunkHeights, subheading));
            });
        }
    }
    getCorrectSubheadingId(Mainheading) {
        return this.state.mainGroupBy === MainGroupConfiguration.Market
            ? Mainheading.sportId
            : Mainheading.id;
    }
    showLiveScheduleNoEventsMessage() {
        return this.cms.IsLiveSchedule && !this.state.hasLoadEvents && this.showMessage();
    }
    shouldShowMessage() {
        return !this.state.hasLoadEvents && !this.cms.IsLiveSchedule;
    }
    shouldShowMainContent() {
        return !this.cms.IsLiveSchedule || (this.cms.IsLiveSchedule && !this.state.isLoading);
    }
    renderMainContent() {
        return this.shouldShowMainContent() && this.state.displayMainHeadings
            .map((mainHeading, mainIndex, mainHeadings) => React.createElement(MainContentWrap, Object.assign({}, this.getMainHeadingProps(mainHeadings, mainIndex), { filterConfig: this.state.getFilterConfig(mainHeading), marketTemplates: this.state.getMarketTemplates(mainHeading.sportId), marketsFilterEnabled: mainHeading.marketsFilterEnabled, key: `main-content-wrap-${mainHeading.id}` }), this.renderEventsContent(mainHeading, mainIndex)));
    }
    render() {
        // TODO: Check if reset is needed => mutating state should not be done in the render
        this.renderedMainheadings = 0;
        this.renderedSubheadings = 0;
        return (React.createElement(React.Fragment, null, this.shouldShowMessage()
            ? this.showMessage()
            : React.createElement(React.Fragment, null,
                this.state.showFavoritesSection && this.renderFavoritesSection(),
                this.renderMainContent(),
                this.showLiveScheduleNoEventsMessage(),
                this.cms.ShowViewAllLive && this.renderViewAllLive(),
                this.cms.ShowViewMore && this.state.showViewMore && this.renderViewMore())));
    }
};
EventListPresenter = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], EventListPresenter);
export { EventListPresenter };
//# sourceMappingURL=EventListPresenter.js.map